import { useState } from "react";

const DEFAULT_ZOOM_OUT_VALUE = 0.3;
const DEFAULT_ZOOM_IN_VALUE = 1.3;
const MAX_ZOOM = 2;
const MIN_ZOOM = 0.1;
const DEFAULT_ZOOM_VALUE = 1

export function useZoom(minZoom = MIN_ZOOM, maxZoom = MAX_ZOOM) {
  const [zoom, setZoom] = useState(DEFAULT_ZOOM_VALUE);

  const handleZoomIn = (val = DEFAULT_ZOOM_IN_VALUE) => {
    setZoom(val > maxZoom ? maxZoom : val);
  };

  const handleZoomOut = (val = DEFAULT_ZOOM_OUT_VALUE) => {
    setZoom(val < minZoom ? minZoom : val);
  };

  const resetZoom = () => {
    setZoom(1);
  };

  const isZoomedOut = zoom < DEFAULT_ZOOM_VALUE;
  const isZoomedIn = zoom > DEFAULT_ZOOM_VALUE;
  const isAtDefaultZoom = zoom === DEFAULT_ZOOM_VALUE;

  return {
    zoom,
    isZoomedIn,
    isZoomedOut,
    resetZoom,
    handleZoomOut,
    handleZoomIn,
    isAtDefaultZoom,
  };
}
